// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__qv9wF","content":"GlobalSearch_content__3owku"};